import { addCurrentUserInfo, createAction, makeActionTrackable } from '@lingoda/core';

interface Payload {
    invoiceAddress: string;
}

export default makeActionTrackable(
    addCurrentUserInfo(createAction<Payload>('student/UPDATE_BILLING_INFO')),
);
